import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentInfo: {
    name: '',
    zipCode: '',
    address: '',
    address2: '',
    telephone: '',
    mobile: '',
    email: '',
    taxNumber: '',
    taxOffice: '',
    identityNumber: '',
    ilgarCompId: '',
    isActive: null,
    isApproved: null,
    createdBy: null,
    createdWhen: null,
    lastEditedBy: null,
    lastEditedWhen: null,
    lastDeletedBy: null,
    lastDeletedWhen: null,
    isDeleted: false,
    countryCode: 'TR',
    countryName: 'Türkiye',
    cityCode: '',
    cityName: '',
    districtName: '',
    shipments: [],
    telephoneCountryCode: '90',
    telephoneAreaCode: '',
    mobileCountryCode: '90',
    mobileAreaCode: '',
  },
  currentType: '',
  currentRowUuid: '',
};

export const currentCreateSlice = createSlice({
  name: 'currentCreate',
  initialState,
  reducers: {
    updateCurrentInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.currentInfo[field] = value;
    },
    importCurrentInfo: (state, action) => {
      state.currentInfo = action.payload;
    },
    updateCurrentTypeField: (state, action) => {
      state.currentType = action.payload;
    },
    clearCurrentInfo: (state) => {
      state.currentInfo = initialState.currentInfo;
    },
    updateCurrentRowUuid: (state, action) => {
      state.currentRowUuid = action.payload;
    },
    clearCurrentRowUuid: (state) => {
      state.currentRowUuid = initialState.currentRowUuid;
    },
  },
});

export const currentInfoSelector = (state) => state.currentCreate.currentInfo;
export const currentTypeSelector = (state) => state.currentCreate.currentType;
export const currentRowUuidSelector = (state) =>
  state.currentCreate.currentRowUuid;
export const isCurrentCompanySelector = (state) =>
  state.currentCreate.currentType === 'işletme';
export const {
  updateCurrentInfoField,
  updateCurrentTypeField,
  clearCurrentInfo,
  importCurrentInfo,
  updateCurrentRowUuid,
  clearCurrentRowUuid,
} = currentCreateSlice.actions;

export const currentCreateReducer = currentCreateSlice.reducer;
export const currentCreateReducerName = currentCreateSlice.name;

export default currentCreateSlice.reducer;
